import { render, staticRenderFns } from "./TransferNoteShortInfo.vue?vue&type=template&id=804ce686&scoped=true"
import script from "./TransferNoteShortInfo.vue?vue&type=script&lang=js"
export * from "./TransferNoteShortInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804ce686",
  null
  
)

export default component.exports